// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js!./global.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  width: 100%;
  /*height: 100%;*/
}
.chart-container {
  width: 100%;
  height: 100%;
  /*box-shadow: 0px 2px 8px 0px rgba(0, 93, 152, 0.15);*/
  background-color: white;
}
`, "",{"version":3,"sources":["webpack://./src/chart.css"],"names":[],"mappings":"AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,sDAAsD;EACtD,uBAAuB;AACzB","sourcesContent":["@import url(\"./global.css\");\n\n:host {\n  width: 100%;\n  /*height: 100%;*/\n}\n.chart-container {\n  width: 100%;\n  height: 100%;\n  /*box-shadow: 0px 2px 8px 0px rgba(0, 93, 152, 0.15);*/\n  background-color: white;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
